export default __webpack_public_path__ + "static/media/Learn button.bcca36c6.png";